module.exports = __webpack_public_path__ + "media/ride.b0d70ec5.wav";